<template>
    <div class="card py-2 mt-2">
      <div class="card-header pb-0">
        <div class="row pb-2">
            <div class="col-4">
                <span> Order ID: {{ order.id }} </span>
            </div>
            <div class="col-4">
                <span class="font-weight-bold">Amount due: {{ order.amount_due }}</span>
            </div>
            <div class="col-4">
                 <span class="badge badge-sm bg-gradient-success">{{ order.status }}</span>
            </div>
        </div>
        <div class="row pb-2">
            <div class="col-3">
                <span class="font-weight-bold"></span> {{ order.first_name }} {{ order.last_name }}
            </div>
            <div class="col-3">
                <span class="font-weight-bold">Address: </span>{{ order.address }}
            </div>
            <div class="col-3">
                <span class="font-weight-bold"></span> {{ order.email }}
            </div>
            <div class="col-3">
                <span class="font-weight-bold"></span>{{ order.phone }} 
            </div>
        </div> 
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Material</th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                >Price</th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >Quantity</th>
                <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >Total</th>
                
              </tr>
            </thead>
            <tbody>
              <tr
              v-for="item in order.items"
              v-bind:key="item.material.id"
              >
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ item.material.name }}</h6>
                    </div>
                  </div>
                </td>
                <td>
                  <p class="text-xs font-weight-bold mb-0">{{ item.material.price }}</p>
                  
                </td>
                <td class="align-middle text-center text-sm">
                  <span class="text-xs font-weight-bold mb-0">{{ item.quantity }}</span>
                </td>
                <td class="align-middle text-center">
                  <span class="text-secondary text-xs font-weight-bold"> {{ getItemTotal(item).toLocaleString() }}</span>
                </td>
                
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "authors-table",
    props: {
        order: Object
    },
    methods: {
        getItemTotal(item) {
            return item.quantity * item.material.price
        },
        orderTotalLength(order) {
            return order.items.reduce((acc, curVal) => {
                return acc += curVal.quantity
            }, 0)
        },
    }
  };
  </script>
  